import * as React from 'react';
import { Spin } from "antd/es";

const style: any = {
  top: 0,
  zIndex: '10',
  width: '100%',
  height: '50px',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

export default function MapDataLoader() {
  return (
    <div style={{ ...style }}>
      <h1>Loading data... <Spin /></h1>
    </div>
  )
}